import type { PhotometricTarget } from '../../utils/photometricTargets';

// Define layer types and their colors
export const LAYER_TYPES = {
  Unspecified: '#000000',
  Sidewalk: '#9CA3AF', // Darker gray
  Pedestrian: '#C2B39A', // Paving beige (pedestrian zones, squares)
  Road: '#4B5563', // Gray
  Environment: '#22C55E', // Green
  Building: '#B45309', // Red
} as const;

// Interface for layer settings
export interface LayerSetting {
  uuid: string;
  groupId?: string | null;
  originalName: string;
  threeJsName: string;
  displayName: string; // User-editable display name
  modelName: string;
  type: keyof typeof LAYER_TYPES;
  illuminated: boolean;
  canHoldLight: boolean;
  norm: string;
  customTargets?: PhotometricTarget[] | null;
  color: string;
  desiredLuminaireHeight: number;
}

export interface ProjectSettingsProps {
  onNext: () => void;
  onBack: () => void;
}
